import TicketHttp from "../../ticketHttp";

class PricingConfigServices {
  // Gateway Fees
  static listGatewayFees(params = {}) { return TicketHttp.get('/pricing-config/gateway-fees', params); }
  static createGatewayFee(data) { return TicketHttp.post('/pricing-config/gateway-fees', data); }
  static updateGatewayFee(id, data) { return TicketHttp.update(`/pricing-config/gateway-fees/${id}`, data); }
  static deleteGatewayFee(id) { return TicketHttp.delete(`/pricing-config/gateway-fees/${id}`); }

  // Platform Fees
  static listPlatformFees(params = {}) { return TicketHttp.get('/pricing-config/platform-fees', params); }
  static createPlatformFee(data) { return TicketHttp.post('/pricing-config/platform-fees', data); }
  static updatePlatformFee(id, data) { return TicketHttp.update(`/pricing-config/platform-fees/${id}`, data); }
  static deletePlatformFee(id) { return TicketHttp.delete(`/pricing-config/platform-fees/${id}`); }

  // Convenience Fees
  static listConvenienceFees(params = {}) { return TicketHttp.get('/pricing-config/convenience-fees', params); }
  static createConvenienceFee(data) { return TicketHttp.post('/pricing-config/convenience-fees', data); }
  static updateConvenienceFee(id, data) { return TicketHttp.update(`/pricing-config/convenience-fees/${id}`, data); }
  static deleteConvenienceFee(id) { return TicketHttp.delete(`/pricing-config/convenience-fees/${id}`); }

  // Discount Rules
  static listDiscountRules(params = {}) { return TicketHttp.get('/pricing-config/discounts', params); }
  static createDiscountRule(data) { return TicketHttp.post('/pricing-config/discounts', data); }
  static updateDiscountRule(id, data) { return TicketHttp.update(`/pricing-config/discounts/${id}`, data); }
  static deleteDiscountRule(id) { return TicketHttp.delete(`/pricing-config/discounts/${id}`); }

  // Coupons
  static listCoupons(params = {}) { return TicketHttp.get('/discounts/coupons', params); }
  static createCoupon(data) { return TicketHttp.post('/discounts/coupons', data); }
  static updateCoupon(id, data) { return TicketHttp.update(`/discounts/coupons/${id}`, data); }
  static deleteCoupon(id) { return TicketHttp.delete(`/discounts/coupons/${id}`); }
  static listRedemptions(params = {}) { return TicketHttp.get('/discounts/redemptions', params); }

  // Payment Gateway Master
  static listGatewaysMaster(params = {}) { return TicketHttp.get('/pricing-config/payment-gateways', params); }
  static createGatewayMaster(data) { return TicketHttp.post('/pricing-config/payment-gateways', data); }
  static updateGatewayMaster(id, data) { return TicketHttp.update(`/pricing-config/payment-gateways/${id}`, data); }
  static deleteGatewayMaster(id) { return TicketHttp.delete(`/pricing-config/payment-gateways/${id}`); }

  // Base GST
  static listBaseGst(params = {}) { return TicketHttp.get('/pricing-config/base-gst', params); }
  static createBaseGst(data) { return TicketHttp.post('/pricing-config/base-gst', data); }
  static updateBaseGst(id, data) { return TicketHttp.update(`/pricing-config/base-gst/${id}`, data); }
  static deleteBaseGst(id) { return TicketHttp.delete(`/pricing-config/base-gst/${id}`); }

  // Preview via v2 pricing
  static calculatePricingV2(data) { return TicketHttp.post('/pricing/v2/calculate', data); }
}

export default PricingConfigServices;
